import html from "remark-html";
import { remark } from "remark";

const Common = {
  ST_RISO_DESIGNED:
    "Designed, printed, and hand-bound at Space Type studio in Brooklyn, NYC.",
  ST_RISO_PRINT_DESIGNED:
    "Designed and printed at Space Type studio in Brooklyn, NYC.",
  ST_RISO_DISCLAIMER:
    "<i>*Riso is a printing process that layers transparent, colored inks to create vibrant images with unique texture qualities. Due to this layering process, slight differences in registration are natural and roller marks may occur. Each product is inspected for quality and sent with care, but may be subject to delivery conditions.</i>",
};

export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function formatMoney(
  currency: string,
  amountTotal: number,
  noCurrency?: boolean
) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    currencyDisplay: "symbol",
  });

  return (
    formatter.format(amountTotal / 100) +
    (noCurrency === true ? "" : ` ${currency}`)
  );
}

export function formatMoneyShort(currency: string, amountTotal: number) {
  return formatMoney(currency, amountTotal).split(".")[0];
}

/** Processes rich text into HTML */
export async function processRichText(txt) {
  if (!txt) {
    return null;
  }

  const processed = await remark().use(html).process(txt);
  let str = processed.toString();
  for (const s of Object.keys(Common)) {
    str = str.replaceAll(`{{${s}}}`, Common[s]);
  }

  return str;
}

export function enumFromStringValue<T>(
  enm: { [s: string]: T },
  value: string
): T | undefined {
  return (Object.values(enm) as unknown as string[]).includes(value)
    ? (value as unknown as T)
    : undefined;
}
